module.exports = __webpack_public_path__ + "static/strategy-and-structure-16ce114b77603e072908193fe78e5e73.jpg";